<template>
    <div>
        <b-table
            id="objectiveTable"
            :items="table"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            striped
            responsive="sm"
            hover>

            <template v-slot:cell(name)="row">
                <a :href="'/objective/' + row.item.id" class="font-weight-bold">
                    {{ row.item.name }}
                </a>
            </template>

            <template v-slot:cell(objective_model_name)="row">
                <span v-if="row.item.objective_model">
                    {{ __(row.item.objective_model.name) }}
                </span>
                <span v-else>
                    ---
                </span>
            </template>

            <template v-slot:cell(value)="row">
                <span v-if="row.item.objective_model">
                    <span v-if="row.item.objective_model.notation === '$'">
                        {{ row.item.value | currency(symbol) }}
                    </span>
                    <span v-if="row.item.objective_model.notation === '%'">
                        {{ row.item.value | number('0.00') }} %
                    </span>
                </span>
                <span v-else>
                    ---
                </span>
            </template>

            <template v-slot:cell(objective_period_name)="row">
                <span v-if="row.item.objective_period">
                    {{ __(row.item.objective_period.name) }}
                </span>
                <span v-else>
                    ---
                </span>
            </template>

            <template v-slot:cell(start_date)="row">
                {{ row.item.start_date | moment('DD/MM/YYYY') }}
            </template>

            <template v-slot:cell(end_date)="row">
                {{ row.item.end_date | moment('DD/MM/YYYY') }}
            </template>

            <template v-slot:cell(status)="row">
                <span v-if="row.item.status === 1" class="text-success text-center">
					<i class="fa fa-circle mr-1"></i> {{ __('objective.Running') }}
                </span>
                <span v-else class="text-center">
					<i class="fa fa-square mr-1"></i> {{ __('objective.Inactive') }}
                </span>
            </template>

            <template v-slot:cell(actions)="row">

                <a :href="'/' + locale + '/objective/' + row.item.id" class="mr-2">
                    <i class="fas fa-eye"></i>
                </a>

                <a :href="'/' + locale + '/objective/edit/' + row.item.id" class="mr-2">
                    <i class="fas fa-edit"></i>
                </a>

                <a href="javascript:;" @click="destroyObjective(row.item.id)" class="text-danger">
                    <i class="fas fa-times"></i>
                </a>

            </template>

        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="objectiveTable"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    props: ['table', 'currency', 'symbol', 'locale'],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: 'name',
            sortDesc: false,
            fields: [
                { key: 'name', label: this.__('objective.Target') },
                { key: 'objective_model_name', label: this.__('objective.Model') },
                { key: 'value', label: this.__('objective.Value') },
                { key: 'objective_period_name', label: this.__('objective.Interval') },
                { key: 'start_date', label: this.__('objective.Start') },
                { key: 'end_date', label: this.__('objective.End') },
                { key: 'status', label: this.__('objective.Status') },
                { key: 'actions', label: this.__('objective.Actions') },
            ],
        }
    },
    computed: {
        rows() {
            return this.table.length
        }
    },
    methods: {
        destroyObjective(id) {
            this.$bvModal.msgBoxConfirm(this.__('objective.Please confirm that you want to delete'), {
                title: this.__('objective.Please Confirm'),
                okVariant: 'danger',
                okTitle: this.__('objective.Yes'),
                cancelTitle: this.__('objective.No'),
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.destroy(id)
                    }
                })
                .catch(err => {
                })
        },

        destroy(id) {
            axios.delete('/' + this.locale + '/objective/' + id)
                .then(result => {
                    window.location.reload()
                })
        }
    }
}
</script>

<style scoped>

</style>
